import TbhLogoWithText from '../../common/TbhLogoWithText';
import '../../App.css';
import { globalIcon } from '../../assets/images/login';
import WeAreGlobal from '../../features/authentication/WeAreGlobal';
import { Box, useMediaQuery } from '@chakra-ui/react';

interface IProps {
  children: any;
}
const AuthWrapper = ({ children }: IProps) => {
  const [isLessThan768] = useMediaQuery('(max-width: 767.98px)');
  return (
    <div className='loginContainer'>
      <Box mt={'2.88rem'}>
        <TbhLogoWithText height={'2rem'} width={'6rem'} />
      </Box>
      <div className='formAndText md:mt-[5rem]'>
        <div className='formContainer'>{children}</div>
        <div className='rightSide'>
          <div className=''>
            <WeAreGlobal />
          </div>
        </div>
      </div>
      <div className='imgContainer'>
        <img src={globalIcon} alt='alt.png' />
      </div>
    </div>
  );
};

export default AuthWrapper;
